var React = require('react');

function RestaurantInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.1154 37.2562V21.9506C10.6803 21.6173 9.46499 20.8719 8.4696 19.7145C7.47424 18.5571 6.97656 17.1821 6.97656 15.5895V3.92285H9.75431V15.5895H12.1154V3.92285H14.8932V15.5895H17.2544V3.92285H20.0321V15.5895C20.0321 17.1821 19.5344 18.5571 18.5391 19.7145C17.5437 20.8719 16.3284 21.6173 14.8932 21.9506V37.2562H12.1154ZM29.1988 37.2562V23.9229H24.3377V11.5617C24.3377 9.33026 25.053 7.49924 26.4835 6.06869C27.9141 4.63813 29.7451 3.92285 31.9766 3.92285V37.2562H29.1988Z","fill":"#0066FF"}));
}

RestaurantInline.defaultProps = {"width":"41","height":"41","viewBox":"0 0 41 41","fill":"none"};

module.exports = RestaurantInline;

RestaurantInline.default = RestaurantInline;
